import React from 'react';
import { Group, Rect, Arc, Line, Circle } from 'react-konva';
import { NAVY, ORANGE, WINDOW_COLOR, WALL_THICKNESS } from '../constants';

/**
 * Renders a door (porta) or window (janela) on the canvas.
 * Door: white gap + 90° dashed arc + straight line
 * Window: white gap + 3 parallel blue lines
 */
export default function EsquadriaShape({
  esquadria,
  x, y,
  sc,
  isSelected,
  editMode,
  onSelect,
}) {
  const { t, rot = 0, sz = 70 } = esquadria;
  const esz = sz * sc;
  const wt = WALL_THICKNESS;

  if (t === 'porta') {
    return (
      <Group x={x} y={y} rotation={rot}>
        {/* White gap in wall */}
        <Rect x={-2} y={-wt} width={esz + 4} height={wt * 2} fill="#FFFFFF" listening={false} />
        {/* Door arc (dashed) */}
        <Arc
          x={0} y={0}
          innerRadius={0}
          outerRadius={esz}
          angle={90}
          stroke="#6B7280"
          strokeWidth={1}
          dash={[3, 3]}
          fill="transparent"
          listening={false}
        />
        {/* Door line */}
        <Line points={[0, 0, esz, 0]} stroke={NAVY} strokeWidth={1.5} listening={false} />
        {/* Clickable area */}
        <Circle
          x={esz / 2} y={0}
          radius={esz / 2 + 4}
          fill="transparent"
          listening={true}
          onClick={(e) => {
            e.cancelBubble = true;
            onSelect && onSelect();
          }}
        />
        {/* Selection indicator */}
        {isSelected && (
          <Circle x={0} y={0} radius={6} fill={ORANGE} stroke="#fff" strokeWidth={2} listening={false} />
        )}
      </Group>
    );
  }

  // Window
  return (
    <Group x={x} y={y} rotation={rot}>
      {/* White gap */}
      <Rect x={0} y={-wt} width={esz} height={wt * 2} fill="#FFFFFF" listening={false} />
      {/* 3 blue lines */}
      {[-2, 0, 2].map(offset => (
        <Line
          key={offset}
          points={[0, offset, esz, offset]}
          stroke={WINDOW_COLOR}
          strokeWidth={offset === 0 ? 0.5 : 1.5}
          listening={false}
        />
      ))}
      {/* Clickable area */}
      <Rect
        x={0} y={-wt - 4}
        width={esz} height={wt * 2 + 8}
        fill="transparent"
        listening={true}
        onClick={(e) => {
          e.cancelBubble = true;
          onSelect && onSelect();
        }}
      />
      {/* Selection indicator */}
      {isSelected && (
        <Circle x={esz / 2} y={0} radius={6} fill={ORANGE} stroke="#fff" strokeWidth={2} listening={false} />
      )}
    </Group>
  );
}
